import type { IconData } from '@stacksjs/iconify-core'

export const arrowRoadmap: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3 8h7m25 16a8 8 0 1 0 0-16H20m-7 32a8 8 0 1 1 0-16h12m-2 16h12M10 8a5 5 0 1 0 10 0a5 5 0 1 0-10 0\"/><path d=\"M13 40a5 5 0 1 0 10 0a5 5 0 1 0-10 0m12-16a5 5 0 1 0 10 0a5 5 0 1 0-10 0m10.269 20.408c.08.494.555.726 1.017.535c.817-.338 2.273-.997 4.479-2.188c1.477-.798 2.45-1.436 3.085-1.916c.793-.598.794-1.57 0-2.169c-.635-.48-1.608-1.118-3.085-1.915c-2.206-1.19-3.662-1.85-4.479-2.188c-.462-.192-.936.041-1.017.535c-.128.776-.269 2.19-.269 4.653s.141 3.877.269 4.653\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default arrowRoadmap
